{
  "collapse": "Strni",
  "expand": "Razširi"
}
